import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeclarationFormCardProps } from 'views/declarations/common/declaration.form.card';
import NewFormCard, { FormCardContainer } from '../../../common/cards/NewFormCard';
import CountryOfDestinationCodeBlock, {
    countryOfDestinationCodeBlockValidation,
} from '../blocks/CountryOfDestinationCodeBlock';
import CountryOfDispatchExportCodeBlock, {
    countryOfDispatchExportCodeBlockOptionalValidation,
} from '../blocks/CountryOfDispatchExportCodeBlock';
import { ExtractValidationSchema } from '../validations/validations';

export const countryOfDestinationCardOptionalValidation = {
    selfValidators: [countryOfDestinationCodeBlockValidation, countryOfDispatchExportCodeBlockOptionalValidation],
};

export const countryOfDestinationCardValidation = countryOfDestinationCardOptionalValidation;
export type CountryOfDestinationCardValidation = ExtractValidationSchema<typeof countryOfDestinationCardValidation>;

interface Props extends DeclarationFormCardProps {}

const CountryOfDestinationCard: FC<Props> = (props) => {
    const { t } = useTranslation('form');

    return (
        <NewFormCard title={t('countryOfDestination')} hidden={props.hidden}>
            <FormCardContainer>
                <CountryOfDestinationCodeBlock />
                <CountryOfDispatchExportCodeBlock />
            </FormCardContainer>
        </NewFormCard>
    );
};
export default CountryOfDestinationCard;
